// Looks like neo's RadioGroupItem but can't be one: it sits inside a <button>,
// and Radix's item is a button too.
export const Radio = ({ selected }: { selected: boolean }) => (
  <span className="flex h-4 w-4 shrink-0 items-center justify-center self-center rounded-full border border-primary transition-colors">
    {selected && <span className="h-2.5 w-2.5 rounded-full bg-primary" />}
  </span>
)
